import React, {useEffect, useState} from 'react'
import StepflowData from "./table/StepflowData";
import ReactFlow, { Controls, Background,} from "react-flow-renderer";
import els from "./elements";
export default function AddGuideStepflow() {
  const [elements, setElements] = useState([]);
  const [reactFlowInstance, setReactFlowInstance] = useState(null);

  useEffect(() => {
    setElements(els);
  }, []);

  const onLoad = (rf) => {
    setReactFlowInstance(rf);
  };

  useEffect(() => {
    if (reactFlowInstance && elements.length) {
      reactFlowInstance.fitView();
    }
  }, [reactFlowInstance, elements]);
  return (
    <div>
    
    <div class="flex flex-wrap justify-center mt-2 border-1 rounded-lg">
    <div className="w-full  flex-1 mt-4 sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl mr-6">
      <div className="">
      <div style={{ height: "64vh", width: "24vw" }} >
      <ReactFlow elements={elements} onLoad={onLoad} fitView={true} nodesDraggable={false}>
      <Controls showInteractive={false} />
      <Background color="#aaa" gap={5} />
      </ReactFlow>
    </div>
      </div>
    </div>
    <div className="w-full font-Montserrat flex-2 sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl mr-6 ml-4">
      <div className="flex mt-10">
        <p className="text-gray-700 text-lg font-semibold">
          Build of Material
        </p>
        <div className="-mt-4 text-gray-400 py-4 font-medium ml-auto">
        {" "}
        QTY:
      </div>
      <div className=" mr-8 ml-2 text-gray-400 font-medium">20</div>
      <button
      type="button"
      class="text-blue-200 -mt-2  font-Montserrat ml-auto bg-transparent font-semibold hover:bg-blue-50   focus:outline-none  rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center  mr-2 mb-2" 
    >
     
      <svg
      className="pt-1"
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_663_5557)">
        <path
          d="M9.53671 2.82133L0.974129 11.2473L0 16L4.82797 15.0413L13.3912 6.61467L9.53671 2.82133ZM2.51255 12.75L1.93674 12.1833L9.48387 4.76667L10.059 5.33267L2.51255 12.75ZM3.87281 14.0887L3.297 13.522L10.8441 6.10533L11.4199 6.672L3.87281 14.0887ZM16.2581 3.79267L14.3505 5.67133L10.4953 1.87733L12.4029 0L16.2581 3.79267Z"
          fill="#1F78B4"
        />
      </g>
      <defs>
        <clipPath id="clip0_663_5557">
          <rect width="16.2581" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
      Edit Step
    </button>
      </div>
      <div className="flex -mt-4 font-Montserrat flex-wrap ">
        <div className=" text-blue-200 py-4 font-medium ">
          {" "}
          Step{`> `}Step Name {`> `}
        </div>
        <div className="mt-4 mr-8 ml-2 text-gray-400 font-medium">Edit</div>
      </div>
      <div className="flex flex-wrap w-fit justify-center">
      <div
        className="tabelcontainer flex-auto  overflow-auto "
        // "w-[calc(100vw_-_12rem)]"
      >
        <StepflowData />
      </div>
    </div>
    </div>
  </div>
  <div className="flex flex-row justify-center mt-12 mb-0 my-10">
    <button
      type="button"
      className="text-red-600 font-Montserrat font-medium text-lg"
      // onClick={() => Navigate("/dashboard/management/customer-dashboard")}
    >
      Go Back
    </button>
    <button
      type="button"
      class="text-blue-200  font-Montserrat ml-auto bg-transparent font-semibold hover:bg-blue-50   focus:outline-none  rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center  mr-2 mb-2" 
    >
      <svg
        className="mr-1 mt-1"
        width="22"
        height="20"
        viewBox="0 0 22 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_807_4358)">
          <path
            d="M6.94498 18.8033L0.788086 20L2.03052 14.0625L6.94498 18.8033ZM3.25222 12.8833L8.16668 17.6242L21.5242 4.74083L16.6089 0L3.25222 12.8833Z"
            fill="#1F78B4"
          />
        </g>
        <defs>
          <clipPath id="clip0_807_4358">
            <rect
              width="20.7361"
              height="20"
              fill="white"
              transform="translate(0.787109)"
            />
          </clipPath>
        </defs>
      </svg>
      Edit Flow step
    </button>
    <button
      type="submit"
      className="text-white float-left bg-green-200 hover:bg-green-100 font-Montserrat font-medium text-lg place-content-center rounded-md pt-2 px-8 flex flex-shrink-1 "
    >
      
      Save Changes
    </button>
  </div>
    </div>
  )
}
